import { render, staticRenderFns } from "./ViewAttribute.vue?vue&type=template&id=2f62cdf4&scoped=true"
import script from "./ViewAttribute.vue?vue&type=script&lang=js"
export * from "./ViewAttribute.vue?vue&type=script&lang=js"
import style0 from "./ViewAttribute.vue?vue&type=style&index=0&id=2f62cdf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62cdf4",
  null
  
)

export default component.exports